module.exports = __webpack_public_path__ + "static/assets/50f828904ccdd230ddc926615b2922f1.svg";